import { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/images/logo.png";
import { LOGIN_URL } from "../constants";

function Navbar() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [productOpen, setProductOpen] = useState(false);

  const closeSidebar = () => {
    setSidebarOpen(false);
    setProductOpen(false);
  };

  return (
    <>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg custom-navbar">
        <div className="container">

          {/* Logo */}
          <NavLink
            className="navbar-brand"
            to="/"
            onClick={closeSidebar}
          >
            <img src={logo} alt="Logo" className="logo" />
          </NavLink>

          {/* Mobile Menu Button */}
          <button
            className="menu-btn d-lg-none"
            onClick={() => setSidebarOpen(true)}
          >
            ☰
          </button>

          {/* Desktop Menu */}
          <div className="d-none d-lg-block ms-auto">
            <ul className="navbar-nav flex-row align-items-center">

              <li className="nav-item">
                <NavLink to="/" className="nav-link">
                  Home
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/about" className="nav-link">
                  About
                </NavLink>
              </li>

              {/* Product Dropdown */}
              <li className="nav-item dropdown">
                <a
                  href="/#"
                  className="nav-link dropdown-toggle"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  Product
                </a>

                <ul className="dropdown-menu">
                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="/crop-booster"
                    >
                      Crop Booster
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="/lady-grow"
                    >
                      Lady Grow
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="/bulet-star"
                    >
                      Blue Star
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="/young-crop"
                    >
                      Young Crop
                    </NavLink>
                  </li>
                </ul>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/business-plan"
                  className="nav-link"
                >
                  Business Plan
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/legal"
                  className="nav-link"
                >
                  Legal
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/contact"
                  className="nav-link"
                >
                  Contact
                </NavLink>
              </li>

              <li className="nav-item">
                <a
                  href={LOGIN_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-link"
                >
                  Login
                </a>
              </li>

            </ul>
          </div>

        </div>
      </nav>

      {/* Overlay */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={closeSidebar}
        ></div>
      )}

      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? "show" : ""}`}>

        <div className="sidebar-header">
          <button
            className="close-btn"
            onClick={closeSidebar}
          >
            ✕
          </button>
        </div>

        <ul className="sidebar-menu">

          <li>
            <NavLink to="/" onClick={closeSidebar}>
              Home
            </NavLink>
          </li>

          <li>
            <NavLink to="/about" onClick={closeSidebar}>
              About
            </NavLink>
          </li>

          {/* Product Dropdown */}
          <li className="sidebar-dropdown">

            <button
              className="sidebar-dropdown-btn"
              onClick={() => setProductOpen(!productOpen)}
            >
              Product
              <span>{productOpen ? "−" : "+"}</span>
            </button>

            {productOpen && (
              <ul className="sidebar-submenu">

                <li>
                  <NavLink
                    to="/crop-booster"
                    onClick={closeSidebar}
                  >
                    Crop Booster
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/lady-grow"
                    onClick={closeSidebar}
                  >
                    Lady Grow
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/bulet-star"
                    onClick={closeSidebar}
                  >
                    Blue Star
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/young-crop"
                    onClick={closeSidebar}
                  >
                    Young Crop
                  </NavLink>
                </li>

              </ul>
            )}
          </li>

          <li>
            <NavLink
              to="/business-plan"
              onClick={closeSidebar}
            >
              Business Plan
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/legal"
              onClick={closeSidebar}
            >
              Legal
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/contact"
              onClick={closeSidebar}
            >
              Contact
            </NavLink>
          </li>

          <li>
            <a
              href={LOGIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeSidebar}
            >
              Login
            </a>
          </li>

        </ul>
      </div>
    </>
  );
}

export default Navbar;